import { useState } from "react";
import { useClerk, useUser } from "@clerk/react";
import { Icone } from "@/components/Icone";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import { CartaoEntrada } from "./CartaoEntrada";

/**
 * O que aparece no lugar do formulário quando o navegador JÁ tem sessão.
 *
 * Sem isto o Clerk deixa a pessoa preencher tudo e só então recusa com
 * "session_exists" — em inglês, sem dizer o que fazer. A saída certa é sair e
 * voltar PARA A MESMA TELA; por isso o `redirectUrl` aponta para ela.
 */
export function SessaoAtiva({ modo }: { modo: "entrar" | "criar" }) {
  const { user, isLoaded } = useUser();
  const { signOut } = useClerk();
  const [saindo, setSaindo] = useState(false);

  const email = user?.primaryEmailAddress?.emailAddress;
  const nome = user?.firstName ?? user?.fullName ?? email ?? "esta conta";
  const destino = modo === "criar" ? "/sign-up" : "/sign-in";

  return (
    <CartaoEntrada
      rotulo="Conta conectada"
      titulo="Você já está conectado"
      descricao={
        isLoaded ? (
          <>
            Como <strong className="text-foreground">{nome}</strong>
            {email && nome !== email ? <span className="block">{email}</span> : null}
          </>
        ) : (
          "Já existe uma conta conectada neste navegador."
        )
      }
    >
      <div className="flex flex-col gap-2.5">
        <Button size="lg" className="w-full" nativeButton={false} render={<a href="/conversas" />}>
          Continuar para o painel <Icone nome="seta-direita" className="h-4 w-4" />
        </Button>
        <Button
          type="button"
          variant="outline"
          size="lg"
          className="w-full"
          disabled={saindo}
          onClick={() => {
            setSaindo(true);
            void signOut({ redirectUrl: destino });
          }}
        >
          {saindo ? <Spinner /> : <Icone nome="sair" className="h-4 w-4" />}
          {modo === "criar" ? "Sair e criar outra conta" : "Sair e entrar com outra conta"}
        </Button>
      </div>
    </CartaoEntrada>
  );
}
